import React from "react";
import Menu from "../../components/Menu";
import Hospital from '../../assets/img/hospital-_1_ black.svg'
import ListCardProfessionalsLoggedIn from "../../components/ListCardProfessionalsLoggedIn";

function ProntoAtendimentoProfessionals() {
  const screenTela =
    <div className='screenContainer' style={{ paddingRight: '0px' }}>
      <div className="row row-container">

        <h1 className="col-12 name-screen"> <img style={{ width: '40px' }} alt="svg" src={Hospital} /> <span className="name-screen-title" >Pronto Atendimento</span> </h1>

        <ListCardProfessionalsLoggedIn />
      </div>
    </div>

  return (
    <Menu screen={screenTela} />
  )
}

export default ProntoAtendimentoProfessionals;